// extracted by mini-css-extract-plugin
export default {"root":"c_pphB"};